__turbopack_context__.v({
  "className": "peydafont_134af14f-module__gcOWFG__className",
});
